module.exports = __webpack_public_path__ + "static/media/typical3.9b7ca7eb.png";